import {isRetentionQueryParam} from "../queryParams";

export function retentionParamsFrom(searchParams?: URLSearchParams): URLSearchParams {
    if (!searchParams) {
        return new URLSearchParams();
    }

    const filteredParamEntries = Array.from(searchParams?.entries())
        .filter(([queryParam]) => isRetentionQueryParam(queryParam));

    return new URLSearchParams(Object.fromEntries(filteredParamEntries));
}